import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  Popover,
  MenuItem,
  useMediaQuery,
  useTheme,
  Skeleton,
  Grid,
} from '@mui/material';
import dp from '../../../Assets/icons/dp.svg';
import debounce from 'lodash.debounce';

import React, { useEffect, useState } from 'react';
import logo from '../../../Assets/logo/logo.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { RiSearch2Line } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import Lottie from 'react-lottie';
import userAnime from '../../../Assets/anime/DxWRHmuFvb.json';
import { FaChevronRight } from 'react-icons/fa';
import fork from '../../../Assets/icons/fork.svg';
import profileIcon from '../../../Assets/icons/profile.svg';
import headset from '../../../Assets/icons/headphone.svg';
import logoutIcon from '../../../Assets/icons/logout.svg';
import { logoutUser } from '../../../store/userSlice';
import Drawers from './Drawers';
import { findRestaurant } from '../../../api';
import { IoStarSharp } from 'react-icons/io5';
import serveImg from '../../../Assets/images/placeholder.png';
import emptyImg from '../../../Assets/icons/empty2.svg';

const Navbar = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const userData = useSelector((state) => state.user?.user);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = () => {
    handleClose();
    dispatch(logoutUser());
    // navigate("/")
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [params, setParams] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const location = useLocation();

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const debouncedSearch = debounce((value) => {
    handleFind(value);
  }, 600);

  const handleFind = async (value) => {
    setIsLoading(true);
    await findRestaurant(value)
      .then((res) => {
        setIsLoading(false);

        if (res?.data?.status) {
          setSearchResult(res?.data?.result);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (params) {
      debouncedSearch(params);
    }
  }, [params]);

  return (
    <>
      <AppBar sx={{ background: '#fff' }}>
        <Box
          sx={{
            width: { xl: '75%', lg: '85%', xs: '90%' },
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '70px',
          }}
        >
          <Link to="/">
            <img src={logo} width={isMobile ? 80 : 100} />
          </Link>
          {isMobile ? (
            <Drawers />
          ) : (
            <>
              {location.pathname !== '/about' && (
                <Box sx={{ width: '40%' }}>
                  <TextField
                    value={params}
                    onChange={(e) => setParams(e.target.value)}
                    fullWidth
                    placeholder="Search restaurants, cuisines or experience"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <RiSearch2Line />
                        </InputAdornment>
                      ),
                      endAdornment: params && (
                        <InputAdornment position="end">
                          <Link to={`/restaurant/find?Text=${params}`}>
                            <Button>Search</Button>
                          </Link>
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '10px',
                      },
                    }}
                  />
                </Box>
              )}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  columnGap: 4,
                }}
              >
                <a href="https://restaurant.reisty.com/" target="_blank">
                  {' '}
                  <Typography color="primary">For Restaurant</Typography>
                </a>

                {isAuthenticated ? (
                  <>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: 3,
                      }}
                    >
                      <Box
                        sx={{
                          py: 1,
                          px: 2,
                          borderRadius: '8px',
                          bgcolor: '#BC172F',
                          width: '100px',
                        }}
                      >
                        <InputLabel
                          sx={{
                            color: '#fff',
                            fontSize: '10px',
                            textAlign: 'center',
                          }}
                        >{`${userData?.first_name} ${userData?.last_name}`}</InputLabel>
                      </Box>
                      <IconButton
                        aria-describedby={id}
                        type="button"
                        onClick={handleClick}
                      >
                        <Avatar src={dp} />
                      </IconButton>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: 3,
                      }}
                    >
                      <Link to="/login">
                        <Button
                          variant="outlined"
                          sx={{
                            border: '1px solid #dadada',
                            borderRadius: '10px',
                            height: '45px',
                            px: 3,
                            color: '#2b2b2b',
                            fontWeight: 400,
                            fontSize: '12px',
                          }}
                        >
                          Log in
                        </Button>
                      </Link>
                      <Link to="/signup">
                        <Button
                          variant="contained"
                          sx={{
                            borderRadius: '10px',
                            height: '45px',
                            px: 4,
                            fontWeight: 400,
                            fontSize: '12px',
                          }}
                        >
                          Sign up
                        </Button>
                      </Link>
                    </Box>
                  </>
                )}
              </Box>
            </>
          )}
        </Box>
      </AppBar>

      {params && (
        <Box
          sx={{
            bgcolor: '#fff',
            p: 2,
            zIndex: 1000,
            position: 'absolute',
            width: '40vw',
            left: '20%',
            maxHeight: '240px',
            overflowY: 'scroll',
            borderRadius: '0px 0px 4px 4px',
          }}
        >
          <Box
            sx={{
              // height: { lg: "70vh", md: "70vh", sm: "auto", xs: "auto" },
              width: '100%',

              boxSizing: 'border-box',
            }}
          >
            {isLoading ? (
              <>
                {[1, 2]?.map((index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      columnGap: 2,
                      alignItems: 'center',
                      width: '80%',
                      px: 1,
                      borderRadius: '10px',
                      mt: -2,
                      boxSizing: 'border-box',
                    }}
                  >
                    <Skeleton sx={{ width: '140px', height: '110px' }} />
                    <Box>
                      <Skeleton variant="text" sx={{ width: '160px' }} />
                      <Skeleton variant="text" sx={{ width: '130px' }} />
                      <Skeleton variant="text" sx={{ width: '90px' }} />
                    </Box>
                  </Box>
                ))}
              </>
            ) : (
              <>
                {!searchResult || searchResult?.Items?.length === 0 ? (
                  <>
                    <Box
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <img src={emptyImg} alt="not-found" />
                      <Typography
                        sx={{ mt: 2, fontWeight: 600, fontSize: '18px' }}
                      >
                        We Couldn't Find That Restaurant on Reisty
                      </Typography>
                      <Typography
                        sx={{ mt: 2, fontWeight: 300, fontSize: '12px' }}
                      >
                        Please modify your search and attempt again.
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <>
                    {searchResult?.Items?.map((restaurant, index) => (
                      <Link to={`/restaurant/${restaurant?.QuerySlot}`}>
                        <Box
                          key={index}
                          sx={{
                            borderRadius: '10px',
                            width: {
                              lg: '80%',
                              md: '80%',
                              sm: '100%',
                              xs: '100%',
                            },
                            p: 1,
                            boxSizing: 'border-box',
                            display: 'flex',
                            columnGap: 2,
                            alignItems: 'center',
                            transition: '0.2s all linear',
                            mb: 2,
                            cursor: 'pointer',
                            '&:hover': {
                              bgcolor: '#BC172F1a',
                              border: '1px  solid #BC172F',
                            },
                          }}
                        >
                          <Avatar
                            src={
                              restaurant?.ImageURL
                                ? restaurant?.ImageURL
                                : serveImg
                            }
                            variant="rounded"
                            sx={{ width: '100px', height: '80px' }}
                          />
                          <Box sx={{ height: '80px' }}>
                            <InputLabel
                              sx={{
                                fontWeight: 600,
                                fontSize: {
                                  lg: '14px',
                                  md: '14px',
                                  sm: '12px',
                                  xs: '12px',
                                },
                                color: '#151515',
                                fontFamily: 'optima',
                              }}
                            >
                              {restaurant?.Name}
                            </InputLabel>
                            <InputLabel
                              sx={{
                                fontSize: {
                                  lg: '12px',
                                  md: '12px',
                                  sm: '10px',
                                  xs: '10px',
                                },
                              }}
                            >
                              {restaurant?.RestaurantType}
                            </InputLabel>
                            <InputLabel
                              sx={{
                                fontSize: {
                                  lg: '10px',
                                  md: '10px',
                                  sm: '8px',
                                  xs: '8px',
                                },
                              }}
                            >
                              {restaurant?.LGA && `${restaurant?.LGA},`}{' '}
                              {restaurant?.State}
                            </InputLabel>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                columnGap: 1,
                                mt: 1,
                              }}
                            >
                              <IoStarSharp style={{ color: '#BC172F' }} />{' '}
                              <Typography sx={{ fontSize: '12px' }}>
                                {restaurant?.Rating}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Link>
                    ))}
                  </>
                )}
              </>
            )}
          </Box>
        </Box>
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ py: 2, px: 1, width: '180px' }}>
          <Link to="/profile">
            <MenuItem sx={{}} onClick={handleClose}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Box
                  sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}
                >
                  <Avatar src={dp} />
                  <Box>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        textTransform: 'capitalize',
                        color: '#565660',
                      }}
                    >
                      Hi, {userData?.first_name}
                    </Typography>
                    <Typography sx={{ color: '#717171', fontSize: '10px' }}>
                      see profile
                    </Typography>
                  </Box>
                </Box>
                <FaChevronRight
                  style={{ color: '#717171', fontSize: '12px' }}
                />
              </Box>
            </MenuItem>
          </Link>
          <Box sx={{ mt: 2 }}>
            <Link to="/profile/reservation">
              <MenuItem
                onClick={handleClose}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: 2,
                  px: 2,
                }}
              >
                <img src={fork} width={15} />
                <Typography
                  sx={{ color: '#2b2b2b', fontWeight: 300, fontSize: '12px' }}
                >
                  Reservations
                </Typography>
              </MenuItem>
            </Link>
            <Link to="/profile">
              <MenuItem
                onClick={handleClose}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: 2,
                  px: 2,
                }}
              >
                <img src={profileIcon} width={15} />
                <Typography
                  sx={{ color: '#2b2b2b', fontWeight: 300, fontSize: '12px' }}
                >
                  Account
                </Typography>
              </MenuItem>
            </Link>
            <Link to="/help">
              <MenuItem
                onClick={handleClose}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: 2,
                  px: 2,
                }}
              >
                <img src={headset} width={15} />
                <Typography
                  sx={{ color: '#2b2b2b', fontWeight: 300, fontSize: '12px' }}
                >
                  Help & Support
                </Typography>
              </MenuItem>
            </Link>
            <MenuItem
              onClick={handleLogout}
              sx={{
                display: 'flex',
                alignItems: 'center',
                columnGap: 2,
                px: 2,
              }}
            >
              <img src={logoutIcon} width={15} />
              <Typography
                sx={{ color: '#2b2b2b', fontWeight: 300, fontSize: '12px' }}
              >
                Logout
              </Typography>
            </MenuItem>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default Navbar;
